var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown-group',[_c('b-dropdown-header',{staticClass:"cursor-pointer",on:{"click":function($event){_vm.visible = !_vm.visible}}},[_vm._t("header"),_c('i',{staticClass:"fa pull-right mt-1",class:_vm.visible ? 'fa-angle-down' : 'fa-angle-left'})],2),(_vm.visible)?[_vm._t("items")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }